// extracted by mini-css-extract-plugin
export var drawerPaper = "_3a-0";
export var itemImage = "_3a-1";